<ng-container>
  <div class="create-container">
    <h3>Create New</h3>
    <div class="input-group">
      <input type="text" class="input-group-input" placeholder="Boomark Name" [(ngModel)]="inputText" />
      <span class="input-group-button">
        <button class="btn" (click)="saveBookmark()">Save</button>
      </span>
    </div>
  </div>

  <div class="catalog-container">
    <h3>Catalog</h3>
    <div class="bookmarks">
      <div *ngFor="let bookmark of bookmarks; let i = index" class="bookmark">
        {{ bookmark.name }}
        <span class="icon icon-ui-close pull-right" (click)="deleteExtent(i)"></span>
        <span class="icon icon-ui-right-arrow pull-right" (click)="goToExtent(i)"></span>
      </div>
    </div>
  </div>
</ng-container>